export default "__VITE_ASSET__7VH7ctBl__"